export default function isChapter(item) {
  return item.__typename === 'Chapter';
}
